/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * Meeting BaaS API
 * OpenAPI spec version: 1.1
 */

export type SpeechToTextProvider = (typeof SpeechToTextProvider)[keyof typeof SpeechToTextProvider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpeechToTextProvider = {
  Gladia: "Gladia",
  Runpod: "Runpod",
  Default: "Default"
} as const
